// extracted by mini-css-extract-plugin
export default {"wrapper":"E0QuV","title":"FQBFb","text":"IYOsR","iconRefresh":"neKw0","button":"qIqxI"};